export default __webpack_public_path__ + "static/media/DMSans-Regular.4ee96395.ttf";